import html2canvas from "html2canvas";

let captureSequence = 0;

export default async function captureElementForPdf(
  element,
  { hideSelectors = [], ignoreActions = false } = {}
) {
  if (!element) {
    return null;
  }

  if (document.fonts?.ready) {
    await document.fonts.ready;
  }

  captureSequence += 1;
  const captureId = `pdf-capture-${captureSequence}`;
  element.dataset.pdfCaptureId = captureId;

  try {
    return await html2canvas(element, {
      backgroundColor: "#ffffff",
      scale: 2,
      useCORS: true,
      logging: false,
      ignoreElements: (candidate) =>
        ignoreActions && candidate.classList?.contains("chart-card__actions"),
      onclone: (clonedDocument) => {
        const clonedRoot = clonedDocument.querySelector(
          `[data-pdf-capture-id="${captureId}"]`
        );
        if (!clonedRoot) {
          return;
        }

        hideSelectors.forEach((selector) => {
          clonedRoot.querySelectorAll(selector).forEach((node) => {
            node.style.display = "none";
          });
        });

        [clonedRoot, ...clonedRoot.querySelectorAll("*")].forEach((node) => {
          if (node.namespaceURI === "http://www.w3.org/1999/xhtml") {
            // A tiny non-zero value makes html2canvas render grapheme by grapheme.
            // This preserves whitespace at line wraps without visibly changing spacing.
            node.style.letterSpacing = "0.01px";
          }
        });
      },
    });
  } finally {
    delete element.dataset.pdfCaptureId;
  }
}
